/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrganisationDTO,
  PatchDocument,
} from '../models/index';
import {
    OrganisationDTOFromJSON,
    OrganisationDTOToJSON,
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
} from '../models/index';

export interface CreateOrganisationRequest {
    organisationDTO: OrganisationDTO;
}

export interface CreateOrganisationsRequest {
    organisationDTO: Array<OrganisationDTO>;
}

export interface DeleteOrganisationRequest {
    organisationId: number;
}

export interface GetPersonsInOrganisationRequest {
    organisationId: number;
}

export interface GetPersonsIncludingChildOrgasRequest {
    organisationId: number;
}

export interface GetReducedOrganisationRequest {
    organisationId: number;
    accept?: string;
}

export interface GetWorksByOrganisationMembersRequest {
    organisationId: number;
}

export interface GetWorksOfOrganisationRequest {
    organisationId: number;
}

export interface UpdateOrganisationRequest {
    organisationId: number;
    patchDocument: Array<PatchDocument>;
}

/**
 * 
 */
export class OrganisationApi extends runtime.BaseAPI {

    /**
     * Creates request options for createOrganisation without sending the request
     */
    async createOrganisationRequestOpts(requestParameters: CreateOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationDTO'] == null) {
            throw new runtime.RequiredError(
                'organisationDTO',
                'Required parameter "organisationDTO" was null or undefined when calling createOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganisationDTOToJSON(requestParameters['organisationDTO']),
        };
    }

    /**
     */
    async createOrganisationRaw(requestParameters: CreateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganisationDTO>> {
        const requestOptions = await this.createOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationDTOFromJSON(jsonValue));
    }

    /**
     */
    async createOrganisation(requestParameters: CreateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganisationDTO> {
        const response = await this.createOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrganisations without sending the request
     */
    async createOrganisationsRequestOpts(requestParameters: CreateOrganisationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationDTO'] == null) {
            throw new runtime.RequiredError(
                'organisationDTO',
                'Required parameter "organisationDTO" was null or undefined when calling createOrganisations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/batch`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['organisationDTO']!.map(OrganisationDTOToJSON),
        };
    }

    /**
     */
    async createOrganisationsRaw(requestParameters: CreateOrganisationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganisationDTO>>> {
        const requestOptions = await this.createOrganisationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganisationDTOFromJSON));
    }

    /**
     */
    async createOrganisations(requestParameters: CreateOrganisationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganisationDTO>> {
        const response = await this.createOrganisationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOrganisation without sending the request
     */
    async deleteOrganisationRequestOpts(requestParameters: DeleteOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling deleteOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteOrganisationRaw(requestParameters: DeleteOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOrganisation(requestParameters: DeleteOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganisationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getPersonsInOrganisation without sending the request
     */
    async getPersonsInOrganisationRequestOpts(requestParameters: GetPersonsInOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getPersonsInOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}/persons`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonsInOrganisationRaw(requestParameters: GetPersonsInOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getPersonsInOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPersonsInOrganisation(requestParameters: GetPersonsInOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getPersonsInOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPersonsIncludingChildOrgas without sending the request
     */
    async getPersonsIncludingChildOrgasRequestOpts(requestParameters: GetPersonsIncludingChildOrgasRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getPersonsIncludingChildOrgas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}/persons/childs`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonsIncludingChildOrgasRaw(requestParameters: GetPersonsIncludingChildOrgasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getPersonsIncludingChildOrgasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPersonsIncludingChildOrgas(requestParameters: GetPersonsIncludingChildOrgasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getPersonsIncludingChildOrgasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getReducedOrganisation without sending the request
     */
    async getReducedOrganisationRequestOpts(requestParameters: GetReducedOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getReducedOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getReducedOrganisationRaw(requestParameters: GetReducedOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganisationDTO>> {
        const requestOptions = await this.getReducedOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationDTOFromJSON(jsonValue));
    }

    /**
     */
    async getReducedOrganisation(requestParameters: GetReducedOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganisationDTO> {
        const response = await this.getReducedOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorksByOrganisationMembers without sending the request
     */
    async getWorksByOrganisationMembersRequestOpts(requestParameters: GetWorksByOrganisationMembersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getWorksByOrganisationMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}/works/persons`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksByOrganisationMembersRaw(requestParameters: GetWorksByOrganisationMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getWorksByOrganisationMembersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getWorksByOrganisationMembers(requestParameters: GetWorksByOrganisationMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getWorksByOrganisationMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorksOfOrganisation without sending the request
     */
    async getWorksOfOrganisationRequestOpts(requestParameters: GetWorksOfOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getWorksOfOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}/works`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksOfOrganisationRaw(requestParameters: GetWorksOfOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getWorksOfOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getWorksOfOrganisation(requestParameters: GetWorksOfOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getWorksOfOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateOrganisation without sending the request
     */
    async updateOrganisationRequestOpts(requestParameters: UpdateOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling updateOrganisation().'
            );
        }

        if (requestParameters['patchDocument'] == null) {
            throw new runtime.RequiredError(
                'patchDocument',
                'Required parameter "patchDocument" was null or undefined when calling updateOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/organisation/{organisationId}`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async updateOrganisationRaw(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganisationDTO>> {
        const requestOptions = await this.updateOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationDTOFromJSON(jsonValue));
    }

    /**
     */
    async updateOrganisation(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganisationDTO> {
        const response = await this.updateOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
